import React from 'react';
import '../Components/fixed.css';

export default function Fixed() {
  return (
    <section id='fixed-button'>
      <a href='tel:+918610867933' className='call-btn'>
        <span className='circle'></span>
        <span className='circle-fill'></span>
        <svg className='phone-icon' xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="#fff" viewBox="0 0 24 24">
          <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1.003 1.003 0 011.11-.21c1.21.49 2.53.76 3.89.76a1 1 0 011 1v3.5a1 1 0 01-1 1C10.07 22.23 1.77 13.93 1.77 3.5a1 1 0 011-1H6.27a1 1 0 011 1c0 1.36.27 2.68.76 3.89a1 1 0 01-.21 1.11l-2.2 2.2z"/>
        </svg>
      </a>
    </section>
  );
}
